import { scale } from '@components/frame';
import type { SkeletonPreset, SkeletonPresetConfig } from '@v2/elements/Skeleton/types';

export const DEFAULT_SHIMMER_DURATION = 1500;
export const DEFAULT_SKELETON_BORDER_RADIUS = scale(4);
export const DEFAULT_SKELETON_WIDTH: number | string = '60%';
export const DEFAULT_SKELETON_HEIGHT = scale(16, false);

export const DEFAULT_CARD_SKELETON = {
  width: '100%' as number | string,
  height: scale(96),
  borderRadius: scale(10),
};

export const SKELETON_PRESET_CONFIG: Record<SkeletonPreset, SkeletonPresetConfig> = {
  footnote: { height: scale(18, false), width: '60%' },
  caption1: { height: scale(16, false), width: '70%' },
  caption2: { height: scale(16, false), width: '50%' },
  body: { height: scale(22, false), width: '60%' },
  headline: { height: scale(22, false), width: '50%' },
  subhead2: { height: scale(20, false), width: '55%' },
};
